import { ColDef, GridOptions } from 'ag-grid-community';

import {
  buildColDef,
  ColType,
  columnSize,
} from 'app/shared/utils/ag-grid.col-def.utils';

export const TRANSFER_ORDER_ITEMS_GRID_COL_DEFS :ColDef[] = [
  buildColDef(
    ColType.DEFAULT,
    {
      headerName: 'SKU',
      field: 'internalSku',
      ...columnSize(12),
    },
    {
      routerLinkFormatter: ({ data }) => `/inventory/${data.rfqId}/view`,
    },
  ),
  buildColDef(
    ColType.DEFAULT,
    {
      headerName: 'Product Name',
      field: 'productName',
      ...columnSize(20),
    },
    {
      routerLinkFormatter: ({ data }) => `/inventory/${data.rfqId}/view`,
    },
  ),
  buildColDef(ColType.DEFAULT, {
    headerName: 'Description',
    field: 'description',
    ...columnSize(20),
  }),
  buildColDef(ColType.QUANTITY, {
    headerName: 'Quantity',
    field: 'orderedQty',
    ...columnSize(10),
  }),
  buildColDef(ColType.CURRENCY, {
    headerName: 'Unit Cost',
    field: 'unitCost',
    ...columnSize(12),
  }),
  buildColDef(ColType.CURRENCY, {
    headerName: 'Line Item Cost',
    field: 'lineItemCost',
    ...columnSize(14),
  }),
];

export const TRANSFER_ORDER_ITEMS_GRID_OPTIONS :GridOptions = {
  defaultColDef: {
    filter: true,
    flex: 1,
    floatingFilter: true,
    resizable: true,
    sortable: true,
  },
  enableCellTextSelection: true,
  rowSelection: 'single',
  suppressCellFocus: true,
  suppressDragLeaveHidesColumns: true,
  suppressMenuHide: true,
  suppressMovableColumns: true,
  suppressRowClickSelection: true,
};
